<div class="h-screen flex flex-col space-y-10 justify-center items-center">
    <ng-lottie [options]="options" class="h-[8rem] sm:h-[10rem] md:h-[12rem]"></ng-lottie>
    <div class="space-y-2 text-center">
        <p class="font-bold text-xl sm:text-2xl md:text-4xl">Operação bem sucedida!</p>
        <p class="text-lg sm:text-xl md:text-2xl">O teu pagamento foi concluído.</p>
    </div>

    <button
        class="px-16 py-2 md:px-20 md:py-3 rounded-full text-lg sm:text-xl md:text-2xl text-white bg-[#40AD53]"
        (click)="close()"
    >
        Sair
    </button>
</div>